export default __webpack_public_path__ + "static/media/omo.349f5e24.png";